// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rules__e2d {
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 1.5);
}

.rules__e2d + .dropdown__dcd {
  margin-top: calc(var(--ring-unit) * 3);
}

.chevron__cb7 {
  margin-left: var(--ring-unit);
  transition: transform ease-in-out 0.3s;

  &.open__edc {
    transform: rotateX(180deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugin-rules-bundle-dialog/plugins-rules-list-wrapper/plugin-rules-list-wrapper.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;;EAEtC;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".rules {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 1.5);\n}\n\n.rules + .dropdown {\n  margin-top: calc(var(--ring-unit) * 3);\n}\n\n.chevron {\n  margin-left: var(--ring-unit);\n  transition: transform ease-in-out 0.3s;\n\n  &.open {\n    transform: rotateX(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rules": `rules__e2d`,
	"dropdown": `dropdown__dcd`,
	"chevron": `chevron__cb7`,
	"open": `open__edc`
};
export default ___CSS_LOADER_EXPORT___;
